// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cna-assignments .library-filters {
  margin-top: 40px;
}
.cna-assignments .library-filters .date-filter__input {
  height: 40px;
}
.cna-assignments .library-filters .date-filter__input + button {
  padding-right: 0;
}
.cna-assignments .library-filters .date-filter__input + button::after {
  padding: 0;
}
.cna-assignments .library-filters.tablet .facility-filter {
  width: 100%;
  margin-bottom: 16px;
  max-width: unset;
}
.cna-assignments .library-filters.tablet .unit-filter {
  max-width: unset;
}
.cna-assignments .library-filters.tablet .left-filters {
  width: 40%;
}
.cna-assignments .library-filters.tablet .right-filters {
  width: 60%;
}
.cna-assignments .library-filters.tablet .right-filters .date-status-filters {
  column-gap: 16px;
}
.cna-assignments .library-filters.tablet .library-filters-wrapper {
  align-items: baseline !important;
}
.cna-assignments .library-filters.tablet .clear-btn {
  margin-top: 16px;
  border: 1px solid var(--Primary-500, #9e77ed);
  color: var(--Primary-500, #9e77ed);
}
.cna-assignments .table-container {
  max-height: initial;
  position: initial;
}
.cna-assignments .table-container .units-table .total-units-value {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #7f56d9;
}
.cna-assignments .table-container .units-table thead .unit {
  max-width: 480px;
}
.cna-assignments .table-container .units-table thead .date {
  width: 210px;
}
.cna-assignments .table-container .units-table__row {
  cursor: pointer;
}
.cna-assignments .table-container .units-table__row:hover {
  background-color: #f9f5ff;
}
.cna-assignments .table-container .react-pagination {
  border-top: 1px solid var(--divider, #eaecf0);
}
.cna-assignments .table-container .react-pagination li {
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/cna/assignments/styles.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAEM;EACE,gBAAA;AAAR;AAEQ;EACE,UAAA;AAAV;AAMM;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;AAJR;AAOM;EACE,gBAAA;AALR;AAQM;EACE,UAAA;AANR;AASM;EACE,UAAA;AAPR;AASQ;EACE,gBAAA;AAPV;AAWM;EACE,gCAAA;AATR;AAYM;EACE,gBAAA;EACA,6CAAA;EACA,kCAAA;AAVR;AAeE;EACE,mBAAA;EACA,iBAAA;AAbJ;AAgBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAdR;AAkBQ;EACE,gBAAA;AAhBV;AAmBQ;EACE,YAAA;AAjBV;AAqBM;EACE,eAAA;AAnBR;AAoBQ;EACE,yBAAA;AAlBV;AAuBI;EACE,6CAAA;AArBN;AAuBM;EACE,yBAAA;UAAA,iBAAA;AArBR","sourcesContent":[".cna-assignments {\n  .library-filters {\n    margin-top: 40px;\n\n    .date-filter__input {\n      height: 40px;\n\n      & + button {\n        padding-right: 0;\n\n        &::after {\n          padding: 0;\n        }\n      }\n    }\n\n    &.tablet {\n      .facility-filter {\n        width: 100%;\n        margin-bottom: 16px;\n        max-width: unset;\n      }\n\n      .unit-filter {\n        max-width: unset;\n      }\n\n      .left-filters {\n        width: 40%;\n      }\n\n      .right-filters {\n        width: 60%;\n\n        .date-status-filters {\n          column-gap: 16px;\n        }\n      }\n\n      .library-filters-wrapper {\n        align-items: baseline !important;\n      }\n\n      .clear-btn {\n        margin-top: 16px;\n        border: 1px solid var(--Primary-500, #9e77ed);\n        color: var(--Primary-500, #9e77ed);\n      }\n    }\n  }\n\n  .table-container {\n    max-height: initial;\n    position: initial;\n\n    .units-table {\n      .total-units-value {\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n        color: #7f56d9;\n      }\n\n      thead {\n        .unit {\n          max-width: 480px;\n        }\n\n        .date {\n          width: 210px;\n        }\n      }\n\n      &__row {\n        cursor: pointer;\n        &:hover {\n          background-color: #f9f5ff;\n        }\n      }\n    }\n\n    .react-pagination {\n      border-top: 1px solid var(--divider, #eaecf0);\n\n      li {\n        user-select: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
